<template>
    <transition name="fade" @after-enter="afterEnter">
        <div class="popup" style="background-image: url('static/img/main/point5/popup/bg.png');" ref="popup">
            <div class="popup-bg delay3"></div>
            <div class="popup-inner ">
                <a href="#" class="close" @click.prevent="closePopup"></a>
                <div class="left delay6">
                    <div class="quotes quotes-right">
                    <span class="text">
                        Я не была в Румынии, но увидеть своими глазами величие Карпатских гор и ощутить силу природы - моя мечта.
                    </span>
                    </div>
                    <div class="info">
                    <span class="point">
                        <span class="text">
                            Карпатские горы, Румыния
                        </span>
                    </span>
                        <h3 class="head">
                            Карпатские горы
                        </h3>
                        <span class="desc">
                        Румынские Карпаты, где Weleda выращивает арнику для своего знаменитого массажного масла, — это регион богатой культуры, в том числе фермерской: большинство местных жителей, занятых в проекте Weleda (более 480 человек ), происходят из семей, в которых навыки собирательства и культивирования передаются по наследству. Урожай арники собирают летом — по особой методике, разработанной вместе со Всемирным фондом дикой природы: с каждого растения снимают ограниченное количество желтых цветков, чтобы популяция дикорастущей арники сохранялась и росла. За восемь лет площадь земель с цветущей арникой серьезно увеличилась — Карпаты становятся по-настоящему «золотыми».
                    </span>
                    </div>
                </div>
                <div class="right delay9">
                    <div class="popup-products">
                        <div class="info">
                            <h4 class="head">
                                Массажное масло <br> с арникой
                            </h4>
                            <span class="desc">
                            100% натуральное масло с арникой, созданное в 1923 году, пользуется доверием среди профессиональных спортсменов и физиотерапевтов. Оно отлично подходит ценителям активного образа жизни.
                        </span>
                            <a href="https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%B0%D1%80%D0%BD%D0%B8%D0%BA%D0%B0?utm_source=afisha&utm_medium=card&utm_content=arnica&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="btn" @click="gaEvents('places','click','know more ')">
                                Подробнее
                            </a>
                        </div>
                        <div class="img">
                            <img src="static/img/main/point5/popup/product.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {TweenMax} from 'gsap';
    import  popupMix from '@/components/pages/popups/popup_mix.vue';

    export default {
        name: 'popup5',
        mixins: [popupMix],
    }
</script>



// WEBPACK FOOTER //
// popup5.vue?8afc8264